export const OPEN_LOGIN_POPUP = "OPEN_LOGIN_POPUP";
export const CLOSE_LOGIN_POPUP = "CLOSE_LOGIN_POPUP";

export const SET_USER = "SET_USER";
export const UNSET_USER = "UNSET_USER";

export const GET_INTERVIEWS = "GET_INTERVIEWS"
